module.exports = __webpack_public_path__ + "media/images/boxes/bip-box500-f3ba4280c8b4364fe50b3f894c6684c1.png";